export const getRequest = (URL) => {
  return fetch(`${URL}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(res => {
    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const postRequest = (URL, payload) => {
  return fetch(`${URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).then(res => {
    return res;
  }).catch(() => {
    console.log(`TypeError: failed to fetch ${URL}`);
  });
};

export const HandlerResponse = (resp) => {
  if (!!resp && resp.status === 200) {
    const jsonPromise = resp.json();

    return jsonPromise.then((data) => {
      return data;
    }).catch((error) => {
      console.log('Successful request, Unexpected end of JSON input', error);
      return null;
    })
  }

  if (!!resp && resp.status === 401) {
    return null;
  }

  return null;
};
